import { render } from "./chinaMap.vue?vue&type=template&id=27e53e08&scoped=true"
import script from "./chinaMap.vue?vue&type=script&lang=js"
export * from "./chinaMap.vue?vue&type=script&lang=js"

import "./chinaMap.vue?vue&type=style&index=0&id=27e53e08&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\乐伴伴10.9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e53e08"]])

export default __exports__